// @flow
import {connect} from 'react-redux';
import type {State as ReduxState} from '../../reducers/index';
import type {Element as ReactElement} from 'react';
import type {SearchQueryResults} from '../../queries/searchQuery';
import type {Shape as HitShape} from '../Hit/Hit';

type StateProps = {
    openExpandedGroupIndexes: number[]
};

type PropsForRenderProp = {
    hits: HitShape[]
};

type Props = StateProps & {
    render: (PropsForRenderProp) => ReactElement<*>,
    results?: SearchQueryResults
};

/**
 *
 * augments hits data with any
 * possibly open expanded search groups hits data
 */
export function MapHitsDataProvider({
    openExpandedGroupIndexes,
    results,
    render,
    ...rest
}: Props) {
    const {expandedSearchGroups, hits: hitCollectionHits} =
        (results && results.hitCollection) || {};
    const expandedSearchGroupsHits =
        (expandedSearchGroups &&
            expandedSearchGroups.reduce(
                (previousValue, expandedSearchGroup, currentIndex) => {
                    if (openExpandedGroupIndexes.includes(currentIndex)) {
                        return [
                            ...previousValue,
                            ...(expandedSearchGroup.hits || [])
                        ];
                    }
                    return previousValue;
                },
                []
            )) ||
        [];

    const hits = [...(hitCollectionHits || []), ...expandedSearchGroupsHits];
    return render({hits, ...rest});
}

const mapStateToProps = ({
    expandedSearchGroups: {openGroupIndexes: openExpandedGroupIndexes}
}: ReduxState): StateProps => ({
    openExpandedGroupIndexes
});

export default connect(mapStateToProps)(MapHitsDataProvider);
